"use client"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableHeader,
} from "@/components/ui/table"

export function BuildingLoadTable() {
  const cellClass = "p-2 align-top"
  const headerClass = "p-2 font-medium text-left align-top"
  const verticalCenteredClass = "flex flex-col justify-center h-full"

  return (
    <div className="w-full overflow-x-auto">
      <Table className="min-w-[800px] text-xs">
        <TableHeader className="sticky top-0 bg-background z-10">
          <TableRow>
            <TableHead className={`${headerClass} w-[15%]`}>
              建築物の部分
            </TableHead>
            <TableHead className={`${headerClass} w-[20%]`} colSpan={3}>
              種別
            </TableHead>
            <TableHead className={`${headerClass} w-[15%]`} colSpan={2}>
              単位面積当たり荷重
              <br />
              (単位 N/m<sup>2</sup>)
            </TableHead>
            <TableHead className={`${headerClass} w-[25%]`}>備考</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell className={cellClass} rowSpan={6}>
              屋根
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              瓦ぶき
            </TableCell>
            <TableCell className={cellClass} colSpan={2}>
              ふき土がない場合
            </TableCell>
            <TableCell className={cellClass} rowSpan={6}>
              屋根面
              <br />
              につき
            </TableCell>
            <TableCell className={cellClass}>640</TableCell>
            <TableCell className={cellClass}>
              下地及び垂木を含み、母屋を含まない
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              ふき土がある場合
            </TableCell>
            <TableCell className={cellClass}>980</TableCell>
            <TableCell className={cellClass}>
              下地及び垂木を含み、母屋を含まない
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass}>
              波形鉄
              <br />
              板ぶき
            </TableCell>
            <TableCell className={cellClass} colSpan={2}>
              母屋に直接ふく場合
            </TableCell>
            <TableCell className={cellClass}>50</TableCell>
            <TableCell className={cellClass}>母屋を含まない</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              薄鉄板ぶき
            </TableCell>
            <TableCell className={cellClass}>200</TableCell>
            <TableCell className={cellClass}>
              下地及び垂木を含み、母屋を含まない
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              ガラス屋根
            </TableCell>
            <TableCell className={cellClass}>290</TableCell>
            <TableCell className={cellClass}>
              鉄製枠を含み、母屋を含まない
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              厚形スレートぶき
            </TableCell>
            <TableCell className={cellClass}>440</TableCell>
            <TableCell className={cellClass}>
              下地及び垂木を含み、母屋を含まない
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={2}>
              木造の
              <br />
              母屋
            </TableCell>
            <TableCell className={cellClass} colSpan={3}>
              母屋の支点間の距離が2m以下の場合
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              屋根面
              <br />
              につき
            </TableCell>
            <TableCell className={cellClass}>50</TableCell>
            <TableCell className={cellClass}></TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              母屋の支点間の距離が4m以下の場合
            </TableCell>
            <TableCell className={cellClass}>100</TableCell>
          </TableRow>
          {/* 天井のセクション */}
          <TableRow>
            <TableCell className={cellClass} rowSpan={6}>
              天井
            </TableCell>
            <TableCell className={cellClass} colSpan={3}>
              さお縁
            </TableCell>
            <TableCell className={cellClass} rowSpan={6}>
              天井面
              <br />
              につき
            </TableCell>
            <TableCell className={cellClass}>100</TableCell>
            <TableCell className={cellClass} rowSpan={6}>
              <div className={verticalCenteredClass}>
                つりき、受木及びその他の下地を含む。
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              繊維板張、打上げ板張、合板張又は金属板張
            </TableCell>
            <TableCell className={cellClass}>150</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              木毛セメント板張
            </TableCell>
            <TableCell className={cellClass}>200</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              格縁
            </TableCell>
            <TableCell className={cellClass}>290</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              しっくい塗
            </TableCell>
            <TableCell className={cellClass}>390</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              モルタル塗
            </TableCell>
            <TableCell className={cellClass}>590</TableCell>
          </TableRow>
          {/* 床のセクション */}
          <TableRow>
            <TableCell className={cellClass} rowSpan={12}>
              床
            </TableCell>
            <TableCell className={cellClass} rowSpan={8}>
              木造の床
            </TableCell>
            <TableCell className={cellClass} colSpan={2}>
              板張
            </TableCell>
            <TableCell className={cellClass} rowSpan={12}>
              床面
              <br />
              につき
            </TableCell>
            <TableCell className={cellClass}>150</TableCell>
            <TableCell className={cellClass}>根太を含む。</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              畳敷
            </TableCell>
            <TableCell className={cellClass}>340</TableCell>
            <TableCell className={cellClass}>床板及び根太を含む。</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={6}>
              床ばり
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              張り間が4m
              <br />
              以下の場合
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              100
            </TableCell>
            <TableCell className={cellClass}></TableCell>
          </TableRow>
          <TableRow></TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={2}>
              張り間が6m
              <br />
              以下の場合
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              170
            </TableCell>
            <TableCell className={cellClass}></TableCell>
          </TableRow>
          <TableRow></TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={2}>
              張り間が8m
              <br />
              以下の場合
            </TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              250
            </TableCell>
            <TableCell className={cellClass}></TableCell>
          </TableRow>
          <TableRow></TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={4}>
              コンクリート造の
              <br />
              床の仕上げ
            </TableCell>
            <TableCell className={cellClass} colSpan={2}>
              板張
            </TableCell>
            <TableCell className={cellClass}>200</TableCell>
            <TableCell className={cellClass}>根太及び大引を含む。</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              フロアリングブロック張
            </TableCell>
            <TableCell className={cellClass}>150</TableCell>
            <TableCell className={cellClass} rowSpan={2}>
              <div className={verticalCenteredClass}>
                仕上げ厚さ1cmごとに、そのセンチメートルの数値を乗ずるものとする。
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              モルタル塗、人造石塗及びタイル張
            </TableCell>
            <TableCell className={cellClass}>200</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              アスファルト防水層
            </TableCell>
            <TableCell className={cellClass}>150</TableCell>
            <TableCell className={cellClass}>
              厚さ1cmごとに、そのセンチメートルの数値を乗ずるものとする。
            </TableCell>
          </TableRow>
          {/* 壁のセクション */}
          <TableRow>
            <TableCell className={cellClass} rowSpan={8}>
              壁
            </TableCell>
            <TableCell className={cellClass} colSpan={3}>
              木造の建築物の壁の軸組
            </TableCell>
            <TableCell className={cellClass} rowSpan={8}>
              壁面
              <br />
              につき
            </TableCell>
            <TableCell className={cellClass}>150</TableCell>
            <TableCell className={cellClass}>
              柱、間柱及び筋かいを含む。
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={3}>
              木造の建築物の
              <br />
              壁の仕上げ
            </TableCell>
            <TableCell className={cellClass} colSpan={2}>
              下見板張、羽目板張又は繊維板張
            </TableCell>
            <TableCell className={cellClass}>100</TableCell>
            <TableCell className={cellClass} rowSpan={3}>
              <div className={verticalCenteredClass}>
                下地を含み、軸組を含まない。
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              木ずりしっくい塗
            </TableCell>
            <TableCell className={cellClass}>340</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={2}>
              鉄網モルタル塗
            </TableCell>
            <TableCell className={cellClass}>640</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} colSpan={3}>
              木造の建築物の小舞壁
            </TableCell>
            <TableCell className={cellClass}>830</TableCell>
            <TableCell className={cellClass}>軸組を含む。</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass} rowSpan={3}>
              コンクリート造の
              <br />
              壁の仕上げ
            </TableCell>
            <TableCell className={cellClass}>しっくい塗</TableCell>
            <TableCell className={cellClass}></TableCell>
            <TableCell className={cellClass}>170</TableCell>
            <TableCell className={cellClass} rowSpan={3}>
              <div className={verticalCenteredClass}>
                仕上げ厚さ1cmごとに、そのセンチメートルの数値を乗ずるものとする。
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass}>モルタル塗及び人造石塗</TableCell>
            <TableCell className={cellClass}></TableCell>
            <TableCell className={cellClass}>200</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={cellClass}>タイル張</TableCell>
            <TableCell className={cellClass}></TableCell>
            <TableCell className={cellClass}>200</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}
